const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Manya Arora</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate Design Head, UPES-CSI</li>
    <li>
        Creative designer with a passion for aesthetics.
    </li>
    <li>
        Crafting visual content for CSI initiatives.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
